
import { Outlet, useNavigation } from 'react-router';

import AppHeader from '../components/layout/AppHeader.jsx';
import AppSidebar from '../components/layout/AppSidebar.jsx';
import PageLoader from '../components/layout/PageLoader.jsx';

export default function AppLayout() {
	
	const navigation = useNavigation();
	const isLoading = navigation.state === 'loading';

	return (
		<div className="flex min-h-dvh bg-[#f3f3f0] text-zinc-950 antialiased dark:bg-[#090a0c] dark:text-white">
			<aside className="sticky top-0 hidden h-dvh w-68 shrink-0 border-r border-white/[0.08] bg-[#0c0d0f] lg:block">
				<AppSidebar />
			</aside>

			<div className="flex min-w-0 flex-1 flex-col">
				<AppHeader />

				<main className="relative min-w-0 flex-1 px-4 py-6 sm:px-6 lg:px-8 lg:py-8">
					{isLoading && <PageLoader />}

					<div className="mx-auto w-full max-w-[100rem]">
						<Outlet />
					</div>
				</main>
			</div>
		</div>
	);
}